
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IFetchData, history } from 'asumsi-components';
import { getToken, clearAllCookie, getRefreshToken, setSessionLogin } from '@helpers/cookies';

interface IHeaders {
  Accept: string;
  Authorization: string;
}

export const FetchData = ({ method, uri, params, additionalHeader, baseUrl }: IFetchData) => {
  const baseUri = baseUrl || process.env.REACT_APP_API_URL;
  const url: string = `${baseUri}${uri}`;
  const token = getToken();
  const defaultHeaders: any = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  if (baseUrl == process.env.REACT_APP_YOUTUBE_API_URL) delete defaultHeaders.Authorization;
  const headers: IHeaders = { ...additionalHeader, ...defaultHeaders, Authorization: token ? defaultHeaders.Authorization : additionalHeader.Authorization };
  const dataOrParams = ['GET', 'DELETE'].includes(method.toUpperCase()) ? 'params' : 'data';
  const defaultConfig: object = { method, headers, url };
  const config: AxiosRequestConfig = { ...defaultConfig, [dataOrParams]: params };

  return new Promise((resolve, reject) => {
    axios(config)
      .then((response: AxiosResponse<any>) => {
        resolve(response);
      })
      .catch(async (error: any) => {
        const { response } = error;
        if (response && response.status === 401 && baseUrl != process.env.REACT_APP_YOUTUBE_API_URL) {
          await RefreshToken();
          resolve(FetchData({ method, uri, params, additionalHeader, baseUrl }));
        } else {
          reject(error);
        }
      });
  });
};


export const ValidateToken = () => {
  const baseUri = process.env.REACT_APP_API_URL;
  const url: string = `${baseUri}/profiles/v1`;
  const token = getToken();
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
  const defaultConfig: object = { method: "GET", headers, url };
  const config: AxiosRequestConfig = { ...defaultConfig };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((response: AxiosResponse<any>) => {
        if (response && response.data.statusCode === 401) {
          RefreshToken();
        } else {
          resolve(response);
        }
      })
      .catch((error: any) => {
        const { response } = error;
        if (response && response.status === 401) {
          RefreshToken();
        } else {
          reject(error);
        }
      });
  });
};

export const RefreshToken = () => {
  const baseUri = process.env.REACT_APP_API_URL;
  const url: string = `${baseUri}/auth/v1/refresh-token`;
  const token = getToken();
  const refreshToken = getRefreshToken();
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
  const defaultConfig: object = { method: "POST", headers, url };
  const config: AxiosRequestConfig = { ...defaultConfig, data: { refreshToken } };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((response: AxiosResponse<any>) => {
        if (response && response.data.statusCode === 401) {
          clearAllCookie();
          history.push({
            pathname: '/',
          });
        } else {
          setSessionLogin(response.data.data);
          resolve(response);
        }
      })
      .catch((error: any) => {
        clearAllCookie();
        history.push({
          pathname: '/',
        });
        reject(error);
      });
  });
};

export default FetchData;



// WEBPACK FOOTER //
// ./src/utils/fetch-data.tsx